import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import './index.css';
import { initMonitoring } from './lib/monitoring';

createRoot(document.getElementById('root')!).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>,
);

// Sentry (with session replay) is ~100KB gzipped; load it after first paint so it
// never competes with the landing page's LCP.
initMonitoring();
